import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { TOOLTIP_DELAY_MS } from '@/constants/deprecated-nodes';

interface DeprecationNoticeProps {
  message: string;
  className?: string;
  compact?: boolean; // For sidebar where space is limited
}

export const DeprecationNotice: React.FC<DeprecationNoticeProps> = ({
  message,
  className,
  compact = false,
}) => {
  const content = (
    <div
      role='alert'
      aria-label='Deprecation warning'
      className={cn(
        'flex items-start gap-2 rounded-md px-3 py-2 bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200',
        compact && 'px-2 py-1.5 items-center',
        className,
      )}
    >
      <AlertTriangle
        className={cn('shrink-0 mt-0.5', compact ? 'size-3 mt-0' : 'size-4')}
      />
      <span
        className={cn(
          'text-xs leading-relaxed',
          compact && 'truncate leading-normal',
        )}
      >
        {compact ? 'Deprecated' : message}
      </span>
    </div>
  );

  // In compact mode, wrap with tooltip to show full message
  if (compact) {
    return (
      <Tooltip delayDuration={TOOLTIP_DELAY_MS}>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent
          side='right'
          align='start'
          sideOffset={12}
          className='max-w-xs'
        >
          <p>{message}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return content;
};
